<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<!-- <c-form-item type="input" label="用户名" name="login_name"></c-form-item> -->
					<c-form-item type="input" label="昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="邀请人手机" name="share_user_manage_mobilephone"></c-form-item>
					<c-form-item type="select" label="等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
					<c-form-item type="checkbox" label="用户状态" name="state" :options="stateType" :value="[1]"></c-form-item>
					<c-form-item type="checkbox" label="授权状态" name="auth_state" :options="authState"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
				<c-button color="sys" icon="add" power="b_platform_user_edit" @click="editUser()">新增用户</c-button>
				<c-button color="black" power="b_platform_set_user_level"  hollow @click="setUserLevel(1)">设置用户等级</c-button>
				<c-button color="black" power="b_platform_set_salesman"  hollow @click="setUserSalesman(1)">设置业务员</c-button>
                <c-button color="red" v-if="userInfo.id == 1"  @click="resetBranchRef()">重置关系树</c-button>
            </m-operate>
            <c-table ref="table">
<!--				<c-table-column-->
<!--					type="selector"-->
<!--				></c-table-column>-->

				<!-- <c-table-column
					label="用户名"
					name="login_name"
					width="110"
				>
				</c-table-column> -->
	            <c-table-column
		            label="昵称"
		            name="nick_name"
		            width="200"
	            >
		            <template v-slot="{data}">
			            <div class="flex-center-cross">
				            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
				            <span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
				            <span v-else>--</span>
			            </div>
		            </template>
	            </c-table-column>

				<c-table-column
						label="手机号"
						name="user_manage_mobilephone"
					  width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.user_manage_mobilephone">
							{{data.user_manage_mobilephone}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="等级"
					name="user_level_name"
				>
					<template v-slot="{data}">
						<span v-if="data.user_level_name && data.user_level_name!='' && data.user_level > -99" style="color:blue">{{data.user_level_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="邀请人"
					name="share_user_phone"
		          width="200"
		        >
					<template v-slot="{data}">
						<span v-if="data.share_user_name">{{data.share_user_name}}</span>
						<span v-if="data.share_user_phone">({{data.share_user_phone}})</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="业务员"
					name="salesman_name"
				>
					<template v-slot="{data}">
						<span v-if="data.salesman_name && data.salesman_name!=''">{{data.salesman_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column> -->

				<c-table-column
					label="下单数"
					name="order_count"
					width="60"
				>
				</c-table-column>

				<c-table-column
					label="退款单数"
					name="refund_count"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="用户ID"
					name="platform_user_id"
				>
				</c-table-column>

				<c-table-column
					label="注册时间"
					name="create_date"
					width="150"
				>
				</c-table-column>

				<c-table-column
					label="注册来源"
					name="user_resource"
					width="100"
				>
					<template v-slot="{data}">
						{{userResourceMap[data.user_resource]}}
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="50"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:darkgreen">启用</span>
						<span v-if="data.state == 2" style="color:red">禁用</span>
					</template>
				</c-table-column>

				<c-table-column
					label="店铺开通状态"
					name="shop_id"
					width="100"
					v-if="systemConfig.oms_seller_shop_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.shop_id == 0" style="color:#bbb">未开通</span>
						<span v-else style="color:darkgreen">已开通</span>
					</template>
				</c-table-column>

				<c-table-column
					label="实名认证"
					name="auth_state"
					width="80"
					v-if="systemConfig.f_config_user_auth_enabled =='ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.auth_state == -1" style="color:#bbb">未认证</span>
						<span v-if="data.auth_state == 0" style="color:blue">审核中</span>
						<span v-if="data.auth_state == 1" style="color:darkgreen">认证通过</span>
						<span v-if="data.auth_state == 2" style="color:red">认证驳回</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="账户余额(元)"
					name="account_balance"
					width="100"
					v-if="systemConfig.account_balance_enabled == 'ON'"
				>
					<template v-slot="{data}">
						￥{{data.account_balance}}
					</template>
				</c-table-column> -->

				<c-table-column
					label="授信额度(元)"
					name="credit_money"
					width="100"
					v-if="systemConfig.credit_pay == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>
				<c-table-column
					label="授信余额(元)"
					name="credit_money"
					width="100"
					v-if="systemConfig.credit_pay == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.credit_money > 0">
							￥{{data.credit_money - data.credit_money_use}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button power="b_platform_user_detail" @click="detail(data)">详情</c-table-button>
						<c-table-button power="b_platform_user_state" v-if="data.state == 2"  @click="updateState(1,data)">启用</c-table-button>
						<c-table-button power="b_platform_user_state" v-if="data.state == 1"  @click="updateState(2,data)">禁用</c-table-button>
						<c-table-button power="b_platform_user_shop" v-if="data.shop_id == 0" @click="openShop(data)">开通店铺</c-table-button>
		                <c-table-button power="b_member_user_change" v-if="data.platform_user_id > 0" @click="setMember(data)">会员调整</c-table-button>
		          </template>
				</c-table-column>
			</c-table>
			<c-dialog ref="editUserDialog" :title="editState ? '编辑用户' : '新增用户'" width="750" @resolve="submitEditUser">
				<c-form ref="edit_form">
					<c-form-item type="hidden" name="id"></c-form-item>
					<c-form-item type="number" decimal="0"  label="手机号" maxlength="11" name="mobile_phone" required word="请输入11位手机号"></c-form-item>
					<!-- <c-form-item type="input" label="用户名" name="login_name" maxlength="16" word="用于登录平台，登录名只允许包含中文、英文字母、数字、下划线，长度在1-16位"></c-form-item> -->
					<c-form-item type="input" label="昵称" name="nick_name" maxlength="30" word="不设置将由系统自动生成，昵称只允许输入中文、英文最大长度为30个字符"></c-form-item>
				</c-form>
			</c-dialog>

			<c-dialog ref="levelEdit" title="设置用户等级" width="500" height="250" @resolve="setLevelHandle">
				<div class="tag-list" style="padding: 20px;">
					<c-radio-group v-model="current_user_level">
						<c-radio v-for="(item, i) in user_level_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
					</c-radio-group>
				</div>
			</c-dialog>

			<c-dialog ref="salesmanEdit" title="设置业务员" width="500" height="250" @resolve="setSalesmanHandle">
				<div class="tag-list" style="padding: 20px;">
					<c-radio-group v-model="current_salesman">
						<c-radio v-for="(item, i) in salesman_list" :key="i" :value="item.value" style="margin-bottom: 20px;">{{item.name}}</c-radio>
					</c-radio-group>
				</div>
			</c-dialog>
	  
			<c-dialog ref="shopEdit" title="开通分销商店铺" width="600" @resolve="submitShop">
				<c-form ref="shopForm">
					<c-form title="基本信息">
						<c-form-item type="input" label="经销商名称" name="company_name" maxlength="30" required></c-form-item>
						<c-form-item type="input" label="店铺名称" name="shop_name" maxlength="50" required></c-form-item>
						<c-form-item type="hidden" name="platform_user_id"></c-form-item>
					</c-form>
					<c-form title="配置信息">
						<c-form-item type="region" label="默认发货地" province-name="delivery_province_id" city-name="delivery_city_id"  required></c-form-item>
						<c-form-item type="select" label="分销商角色" name="auth_id" options="SELLER_AUTH" required></c-form-item>
						<c-form-item type="radio" label="清分方式" name="liquidation_type" :options="liquidationType" required></c-form-item>
						<c-form-item type="number" label="" name="liquidation_date" :limit="[0,100]" word="天"></c-form-item>
					</c-form>
				</c-form>
			</c-dialog>

		<c-dialog ref="memberDialog" title="调整会员邀请人/等级" width="660" height="860" @resolve="setMemberHandle">
			<c-form ref="memberForm">
				<c-form-item type="input" label="当前用户信息:" name="curr_user_info" disabled> </c-form-item>
				<c-form ref="shareForm" title="调整邀请人" title-margin="10">
					<c-form-item type="input" label="当前邀请人:" name="share_user_name" disabled> </c-form-item>
					<c-form-item type="hidden" name="share_user_id"></c-form-item>
					<c-form-item type="input" @click="$refs.memberUserSelector.open()" readonly label="修改为:" name="tran_share_user_name" required word="调整后该用户后续带来的收益奖归于新的邀请人下"></c-form-item>
				</c-form>
				<c-form title="调整等级" title-margin="10">
					<c-form-item type="input" label="当前等级:" name="user_level_name" disabled></c-form-item>
					<c-form-item type="select" label="调整为:" v-model="user_level" name="user_level" options="USER_LEVEL_AUTH" required></c-form-item>
				</c-form>
				<c-form ref="serviceCenterForm" title="门店信息" v-show="user_level == 2">
					<c-form-item type="input" label="门店名称" name="center_name" required></c-form-item>
					<c-form-item type="input" label="门店联系人" name="contacts" required></c-form-item>
					<c-form-item type="input" label="门店联系电话" name="phone_number" required> </c-form-item>
					<c-form-item type="region" label="门店地址"  province-name="province_id" city-name="city_id"  county-name="county_id" required></c-form-item>
					<c-form-item type="input" label="详细地址" name="address" required></c-form-item>
				</c-form>
			</c-form>
		</c-dialog>
      <member-user-selector ref="memberUserSelector" @resolve="selectHandle($event, 'memberList', 'platform_user_id')"></member-user-selector>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
  import memberUserSelector from "@/components/service/member_user_selector.vue";

  export default {
		name: 'm_platform_user',
		components: {memberUserSelector},

		data() {
			return {
				editState: false,   //编辑或是新增  true=编辑  false=新增
				userResourceMap: {
						  'OMS':'管理后台',
						  'PC':'PC电脑',
              'IOS':'苹果APP',
              'ANDROID':'安卓APP',
              'MINI':'微信小程序',
              'BARGAIN':'砍价页',
              'H5':'H5页'
				},
				stateType:[
					{name:'启用', value:1},
					{name:'禁用', value:2},
				],
				authState:[
					{name:'已授权', value:1},
					{name:'未授权', value:2},
				],
				liquidationType:[
				  {
				    name:'发货后',
				    value:1
				  }, {
				      name:'确认收货后',
				      value:2
				  }
				],
				current_user_level:-99,//当前选中的等级
				user_level_list:[],//用户等级列表
				current_salesman:'',//当前选中的业务员
				salesman_list:[],//业务员列表
				user_level: -99
			}
		},
		computed: {
            ...mapState(['userInfo', 'systemConfig']),
		},
		watch: {
			user_level(val){
				//如果新数据为门店
				if(val == 2){
					this.queryUserShop();
				}
			}
		},
		mounted() {
			this.$refs.search.search();
		},

		methods: {
			selectHandle(list, ref, key) {
				var tran_share_user_name = "--";
				var share_user_id = -1;
				if (list && list[0]){
				  console.log(list[0]);
				  tran_share_user_name = (list[0].nick_name || "--") + "【" + list[0].user_manage_mobilephone||"--" + "】";
				  share_user_id = list[0].platform_user_id||-1;
				}
				this.$refs.shareForm.set({
				  tran_share_user_name: tran_share_user_name,
				  share_user_id: share_user_id,
				});
			},
			searchHandle(data) {
				data.query_type = 1;
				this.$refs.table.load({
					url: '/platform_user/list',
					data
				});
			},
			detail(val) {
				this.navigateTo({
					path: '/member/'+val.platform_user_id,
				});
			},
			updateState(type,val) {
				this.$confirm({
					text: '确定要'+(type==1?'启用':'禁用')+'【'+val.user_manage_mobilephone+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/platform_user/update_state',
							data: {platform_user_id:val.platform_user_id,state:type},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
      /**打开 新增/编辑 弹窗**/
      editUser(){
          //清空表单数据
          this.$refs.edit_form.clear();
          this.editState = false;//新增
          this.$refs.editUserDialog.open();
          this.$refs.edit_form.set({});
      },
      /**提交修改**/
      submitEditUser(stop){
        stop();
        this.$refs.edit_form.submit({
          url: '/platform_user/add',
          rule: {
            mobile_phone: '请输入用户手机号'
          },
          success: (data, res) => {
              //关闭弹窗
              this.$refs.editUserDialog.close();
              this.$message({
                  text:'操作成功！'
              });
              // 清空表单数据
              this.$refs.edit_form.clear();
              this.$refs.search.search();
          }
        });
      },
      /***批量修改用户等级**/
      setUserLevel(batch,item) {
        this.userIds = [];
        if(batch == 1){//批量设置
            var list = this.$refs.table.getRow('selected');
            if (!list.length) {
              this.$message({
                text: '请选择要操作的用户'
              });
              return;
            }
            this.userIds = Array.from(list,item=>{
              return item.data.platform_user_id;
            })
        }else{//单个设置
            this.userIds.push(item.platform_user_id);
        }
        this.request({
          url: '/user_level/options',
          data: {},
          loading: true,
          success: data => {
            this.user_level_list = data;
            this.$nextTick(() => {
                this.current_user_level = -1;
            });
            this.$refs.levelEdit.open();
          }
        });
      },
      //设置用户等级
      setLevelHandle(stop) {
        stop();
        if (this.current_user_level==-99) {
          this.$message({
            text: '请选择用户等级'
          });
          return;
        }
        this.request({
          url: '/platform_user/set_level',
          data: {
            user_ids: this.userIds,
            user_level: this.current_user_level
          },
          loading: true,
          success: data => {
              this.$message({
                text: '设置用户等级请求发送成功，调整结果可能稍有延迟！'
              });
              this.$refs.levelEdit.close();
              //延迟刷新页面
            setTimeout(() => {
                this.$refs.table.update();
              }, 1000);
          }
        });
      },
      /***批量修改用户业务员**/
      setUserSalesman(batch,item) {
        this.userIds = [];
        if(batch == 1){//批量设置
            var list = this.$refs.table.getRow('selected');
            if (!list.length) {
              this.$message({
                text: '请选择要操作的用户'
              });
              return;
            }
            this.userIds = Array.from(list,item=>{
              return item.data.platform_user_id;
            })
        }else{//单个设置
            this.userIds.push(item.platform_user_id);
        }
        this.request({
          url: '/sys_user/options',
          data: {},
          loading: true,
          success: data => {
            this.salesman_list = data;
            this.$nextTick(() => {
              this.current_salesman = '';
            });
            this.$refs.salesmanEdit.open();
          }
        });
      },
      /**********重置关系树**************/
      resetBranchRef() {
        this.$confirm({
            text: '重置关系树将根据会员表中的邀请人重新生成邀请关系树，是否确认重置？',
            buttonName: '确认重置',
            resolve: () => {
                this.request({
                    url: '/platform_user/init/branch',
                    data: {},
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '重置成功'
                        });
                        this.$refs.table.update();
                    }
                });
            }
        });
      },
      //设置用户业务员
      setSalesmanHandle(stop) {
        stop();
        if (!this.current_salesman) {
          this.$message({
            text: '请选择业务员'
          });
          return;
        }
        this.request({
          url: '/platform_user/set_salesman',
          data: {
            user_ids: this.userIds,
            salesman_id: this.current_salesman
          },
          loading: true,
          success: data => {
            this.$message({
              text: '设置业务员成功'
            });
            this.$refs.salesmanEdit.close();
            //刷新页面
            this.$refs.table.update();
          }
        });
      },
	    //开通店铺
	    openShop(val){
        this.$refs.shopForm.clear();
        val.company_name = val.nick_name;
        val.shop_name = val.nick_name+'的小店';
        this.$refs.shopForm.set(val);
        this.$refs.shopEdit.open();
      },
	    submitShop(stop) {
		stop();
		this.$refs.shopForm.submit({
		  url: '/platform_user/openShop',
		  rule: {
			company_name: '请输入经销商名称',
			shop_name: '请填写店铺名称',
			delivery_city_id : '请选择发货地',
			auth_id: '请选择分销商家角色',
			liquidation_type: '请选择清分方式',
			liquidation_date: '请输入清分延迟天数'
		  },
		  dataFormatter: data => {
			return data;
		  },
		  success: (data, res, msg) => {
			this.$confirm({
			  icon: 'success',
			  text: msg,  // 提示内容,
			  buttonName: '确定',  // 确定按钮文字
			  cancelButton: false  // 是否显示取消按钮
			});
			this.$refs.table.update();
			this.$refs.shopEdit.close();
		  }
		});
	  },
      //调整会员等级
      setMember(data) {
        this.$refs.memberForm.clear();
        this._edit = data;
        this.$refs.memberForm.set({
			curr_user_info: (data.nick_name || "") + "【" + (data.user_manage_mobilephone||'-') + "】",
			share_user_name: (data.share_user_name || "") + "【" + (data.share_user_phone||'--') + "】",
			tran_share_user_name: (data.share_user_name || "") + "【" + (data.share_user_phone||'--') + "】",
			user_level_name: data.user_level_name||'普通用户',
			share_user_id: data.share_user_id,
			user_level: data.user_level>0?data.user_level:-99,
			nick_name: data.nick_name,
			user_manage_mobilephone: data.user_manage_mobilephone
        });
        this.$refs.memberDialog.open();
      },
      //保存调整会员等级
      setMemberHandle(stop) {
        stop();
        this.$refs.memberForm.submit({
          url: '/member_user/adjustment',
          rule: {
            share_user_id: '请设置邀请人',
			user_level: '请设置等级',
			center_name: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店名称'
			}],
			contacts: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店联系人'
			}],
			phone_number: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店联系电话'
			}],
			province: [{
			    type: 'function',
			    fun: (v , data) => {
			        if(this.user_level == 2 && !data.county_id){
						return false;
					}else{
						return true;
					}
			    },
			    word: '请选择门店地址'
			}],
			address: [{
			    type: 'empty',
			    skip: () => {
			        return this.user_level != 2;
			    },
			    word: '请填写门店详细地址'
			}]
          },
          dataFormatter: data => {
            data.member_user_id = this._edit.platform_user_id;
            data.user_level = data.user_level||0;
            delete data.tran_share_user_name;
            return data;
          },

          success: data => {
            this.$refs.memberDialog.close();
            this.$message({
              text: '请求发送成功，调整结果可能稍有延迟!'
            });
            //延迟500ms刷新页面
            setTimeout(() => {
              this.$refs.table.update();
            }, 1000);
          }
        })
      },
		//查询用户门店信息
		queryUserShop(){
			this.request({
				url: '/service_center/detail',
				data: {
					user_id: this._edit.platform_user_id
				},
				success: data => {
					if(data){
						this.$refs.serviceCenterForm.set(data);
					}
				}
			});
		}
		}
	}
</script>